import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const VARIANTS = ["primary", "success", "danger"];

const ConfirmationModal = ({ show, onHide, onConfirm, title, message, showReason = false, variant = "primary" }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState("");
    const tone = VARIANTS.includes(variant) ? variant : "primary";

    useEffect(() => {
        if (show) setReason("");
    }, [show]);

    return (
        <Modal show={show} onHide={onHide} centered contentClassName="bg-surface border-0">
            <Modal.Header closeButton className="border-0 pb-0">
                <div className="d-flex align-items-center gap-2">
                    <div data-testid="confirmation-accent" className={`modal-accent modal-accent--${tone}`} />
                    <h4 className="modal-title mb-0 txt-main">{title}</h4>
                </div>
            </Modal.Header>

            <Modal.Body className="pt-3">
                <p className="mb-0 txt-subtle">{message}</p>

                {showReason && (
                    <Form.Group className="mt-3">
                        <Form.Label className="txt-subtle mb-1 small fw-semibold">
                            {t("components.ConfirmationModal.reason_label")}
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            className="shadow-none"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder={t("components.ConfirmationModal.placeholder")}
                        />
                    </Form.Group>
                )}

                <div className="d-flex justify-content-end gap-3 mt-4">
                    <Button variant="secondary" onClick={onHide}>
                        {t("components.ConfirmationModal.cancel")}
                    </Button>
                    <Button variant={tone} onClick={() => onConfirm(reason)} disabled={showReason && !reason.trim()}>
                        {t("components.ConfirmationModal.confirm")}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationModal;
